export const icons = [
	{ name: 'Phone', id: 'Phone', w: 20, h: 20 },
	{ name: 'Telegram', id: 'icon-Telegram', w: 20, h: 20 },
	{ name: 'Whatsapp', id: 'icon-Whatsapp', w: 20, h: 20 },
	{ name: 'Viber', id: 'icon-Viber', w: 20, h: 20 },
	{ name: 'Mobile', id: 'icon-Mobile', w: 20, h: 20 },
	{ name: 'Email', id: 'email0', w: 20, h: 20 },
];
